import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  ingredients,
  styled,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useEffect } from "react";
import { useStyles } from "./styles";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import DeleteModal from "../../../common/DeleteModal";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import useInstitution from "../../../Hooks/institution";
import * as Yup from "yup";
import Loader, { TableLoader } from "../../../common/Loader";
import CustomPagination from "../../../common/Pagination";
import { useState } from "react";
import usePagination from "../../../common/usePagination";
import { useCallback } from "react";
import { max } from "lodash";
import { setRedirection } from "../../../store/arrival";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import useAuthStore from "../../../Hooks/auth";
const PinkSwitch = styled(Switch)(({ theme }) => ({
  "&.MuiSwitch-root": {
    zIndex: -1,
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#25D5A1",
    zIndex: -1,
    "&:hover": {
      // backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#25D5A1",
  },
}));

const label = { inputProps: { "aria-label": "Toggle" } };

const Months = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
]

const columns = [
  {
    id: "S.No",
    label: "S.No",
    align: "center",
    sortby: true,
  },
  {
    id: "name",
    sortby: true,
    label: "Name",
    align: "center",
  },
  {
    id: "emailId",
    sortby: true,
    label: "Email Id",
    align: "center",
  },
  {
    id: "mobileNumber",
    label: "Mobile Number",
    align: "center",
    sortby: true,
  },
  {
    id: "adminName",
    label: "Admin Name",
    align: "center",
    sortby: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    align: "center",
    sortby: true,
  },
  {
    id: "endDate",
    label: "End Date",
    align: "center",
    sortby: true,
  },
  {
    id: "totalNoOfUsers",
    label: "Active User Count",
    align: "center",
    sortby: true,
  },
  {
    id: "inActiveUsers",
    label: "Inactive User Count",
    align: "center",
    sortby: true,
  },
  {
    id: "action",
    label: "Actions",
    align: "center",
  },
  {
    id: "delete",
    label: "Status",
    align: "center",
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
  },
];
const number =
  /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
const institutionListSchema = Yup.object().shape({
  endDate: Yup.date()
    .when("startDate", (startDate, schema) => {
      console.log("startDate", startDate, schema);
      if (startDate) {
        const dayAfter = new Date(startDate.getTime());
        return schema.min(
          dayAfter,
          "* Date range looks incorrect"
          // "* The 'To' date cannot be earlier than the 'From' date. Please select a valid date range."
        );
      }
      return schema;
    })
    .required("* please enter the to date")
    .nullable(),
  startDate: Yup.date()
    .required("* please enter the from date")
    .nullable(),
  name: Yup.string().required("* Please enter name"),
  emailId: Yup.string().email().required("* Please enter email "),
  mobileNumber: Yup.string()
    .matches(number, "please enter a valid")
    .max(10)
    .required("*Please enter phone number"),
  address: Yup.string(),
  migrationMonth: Yup.string().required("* Please choose migration month"),
});
const Institutions = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);

  const minDate = new Date("01/01/1950");
  const maxDate = new Date(); 
  const navigate = useNavigate();
  const {
    institutionData,
    loading,

    activeInstitution,
    redirect,
    getInstitutionAction,
    updateInstitutionAction,
    deleteInstitutionAction,
    addInstitutionAction,
    setActiveInstitutionAction,
    setRedirectAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useInstitution();

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    // setPage(1);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const { changeRoleAction } = useAuthStore();
  const initValues = {
    emailId: "",
    mobileNumber: "",
    address: "",
    name: "",
    startDate: "",
    endDate: "",
    migrationMonth: "",
  };

  const count =
    (institutionData &&
      Math.ceil(
        (institutionData?.totalNoOfRecords?.totalNoOfRecords || 0) / perPage
      )) ||
    0;

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
    },
    [perPage, page]
  );

  useEffect(() => {
    setRedirectAction(false);
  }, []);

  useEffect(() => {
    getInstitutionAction({
      limit: perPage,
      offset: offset,
    });
  }, [perPage, offset]);

  return (
    <Stack className={classes.arrival}>
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      <Grid container>
        <Grid item lg={10} xl={10} sm={12}>
          <Stack>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <Typography
                    sx={{ py: 2 }}
                    className={classes.add_course_text}
                  >
                    Add New Institutions
                  </Typography>
                  <Formik
                    initialValues={initValues}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validationSchema={institutionListSchema}
                    onSubmit={(values, { resetForm }) => {
                      addInstitutionAction(values);
                      resetForm({ values: "" });
                    }}
                  >
                    {(formik) => {
                      const {
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        values,
                      } = formik;
                      return (
                        <form onSubmit={handleSubmit}>
                          {/* {loading? (<div><Loader /></div>):(  */}
                          <div>
                            {/* {JSON.stringify(errors)} */}
                            <Grid
                              container
                              sx={{ py: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Name
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="name"
                                      name="name"
                                      placeholder="Enter name"
                                      className={
                                        errors.name && touched.name
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.name}
                                    />
                                    <ErrorMessage
                                      name="name"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Email
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="emailId"
                                      type="email"
                                      name="emailId"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.emailId}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      placeholder="Enter email"
                                    />
                                    <ErrorMessage
                                      name="emailId"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                      sx={{ pr: 2 }}
                                    >
                                      Mobile
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="mobileNumber"
                                      name="mobileNumber"
                                      type="number"
                                      placeholder="Enter mobile"
                                      className={
                                        errors.mobileNumber &&
                                          touched.mobileNumber
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.mobileNumber}
                                    />
                                    <ErrorMessage
                                      name="mobileNumber"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                      sx={{ pr: 2 }}
                                    >
                                      Address
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="address"
                                      name="address"
                                      placeholder="Enter address"
                                      className={
                                        errors.address && touched.address
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.address}
                                    />
                                    <ErrorMessage
                                      name="address"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                      sx={{ pr: 2 }}
                                    >
                                      From
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      sx={{
                                        width: "250px",
                                      }}
                                      id="startDate"
                                      type="date"
                                      name="startDate"
                                      placeholder="Enter Date From"
                                      className={
                                        errors.startDate && touched.startDate
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.startDate}
                                    />
                                    <ErrorMessage
                                      name="startDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                    >
                                      To
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      sx={{
                                        width: "250px",
                                      }}
                                      id="endDate"
                                      type="date"
                                      name="endDate"
                                      placeholder="Enter Date To"
                                      className={
                                        errors.endDate && touched.endDate
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.endDate}
                                    />
                                    <ErrorMessage
                                      name="endDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Migration Month
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <Select
                                      id="migrationMonth"
                                      name="migrationMonth"
                                      className={
                                        errors.migrationMonth && touched.migrationMonth
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.migrationMonth}
                                      onChange={handleChange}
                                      IconComponent={CustomExpandMore}
                                      sx={{
                                        width: "250px",
                                        display: "flex",
                                      }}
                                      displayEmpty
                                    >
                                      <MenuItem disabled value="">
                                        <span>Select Migration Month</span>
                                      </MenuItem>
                                      {Months?.map((month) => (
                                        <MenuItem value={month.id}>
                                          {month.name}
                                        </MenuItem>
                                      ))
                                      }
                                    </Select>
                                    <ErrorMessage
                                      name="migrationMonth"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ pb: 2, justifyContent: "flex-end" }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                    ></Typography>
                                  </Stack>
                                  <Stack>
                                    <Button
                                      type="submit"
                                      sx={{
                                        px: 1,
                                        py: 1.5,
                                        borderRadius: "50px",
                                        width: "220px",
                                      }}
                                      className={classes.add_arrival}
                                    >
                                      Add Institutions
                                    </Button>
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                          </div>
                          {/* )} */}
                        </form>
                      );
                    }}
                  </Formik>
                </Stack>
              </Paper>
            </Box>
          </Stack>
          <Stack sx={{ marginTop: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                  maxHeight: "575px",
                  overflowY: "auto",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    {loading ? (
                      <div>
                        {" "}
                        <TableLoader />
                      </div>
                    ) : (
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                      >
                        <TableHead style={{ position: "sticky", top: 0 }}>
                          <TableRow classes={{ root: classes.thead }}>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {institutionData?.institutions?.length > 0 ? (
                            institutionData?.institutions?.map((_el, index) => (
                              <TableRow tabIndex={-1} key={index}>
                                {columns.map((column) => {
                                  // const value = _el[column.id];
                                  //console.log("el value", _el);
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "S.No" ? (
                                        <Stack sx={{ alignItems: "center" }}>
                                          <span>{offset + index + 1}</span>
                                          {/* <Checkbox defaultChecked /> */}
                                        </Stack>
                                      ) : column.id === "name" ? (
                                        _el.name
                                      ) : column.id === "emailId" ? (
                                        _el.emailId
                                      ) : column.id === "mobileNumber" ? (
                                        _el.mobileNumber
                                      ) : column.id === "adminName" ? (
                                        _el.adminName
                                      ) : column.id === "startDate" ? (
                                        _el.startDate
                                      ) : column.id === "endDate" ? (
                                        _el.endDate
                                      ) : column.id === "totalNoOfUsers" ? (
                                        _el.totalNoOfUsers
                                      ) : column.id === "inActiveUsers" ? (
                                        _el.inActiveUsers
                                      ) : column.id === "action" &&
                                        _el.status === "Active" ? (
                                        <Stack
                                          direction="row"
                                          spacing={2}
                                          justifyContent={"center"}
                                          alignItems={"center"}
                                        >
                                          <Stack
                                            textAlign={"center"}
                                            margin={"auto"}
                                            alignItems={"center"}
                                            component={"button"}
                                            bgcolor={"transparent"}
                                            onClick={() => {
                                              changeRoleAction({
                                                role: "admin",
                                                institutionId: _el.id,
                                              });
                                              navigate("/");
                                            }}
                                          >
                                            <SupervisorAccountIcon />
                                            <Typography variant="caption">
                                              Admin
                                            </Typography>
                                          </Stack>
                                          <Stack
                                            textAlign={"center"}
                                            margin={"auto"}
                                            alignItems={"center"}
                                            component={"button"}
                                            bgcolor={"transparent"}
                                            onClick={() => {
                                              changeRoleAction({
                                                role: "Staff",
                                                institutionId: _el.id,
                                              });
                                              navigate("/");
                                            }}
                                          >
                                            <AdminPanelSettingsIcon />
                                            <Typography variant="caption">
                                              Staff
                                            </Typography>
                                          </Stack>
                                        </Stack>
                                      ) : column.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            navigate(
                                              "/institution/updateInstitution",
                                              {
                                                state: _el,
                                              }
                                            );
                                          }}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : column.id === "delete" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setActiveInstitutionAction(_el.id);
                                            setOpen(true);
                                          }}
                                        >
                                          {/* <img src={Close} alt="close" /> */}
                                          <PinkSwitch
                                            {...label}
                                            defaultChecked
                                            checked={
                                              _el.status === "Active"
                                                ? true
                                                : false
                                            }
                                            onChange={(event) => {
                                              console.log(
                                                "_el.id",
                                                event.target.checked
                                              );
                                            }}
                                          />
                                        </Stack>
                                      ) : (
                                        <Stack>-</Stack>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={6}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                  {institutionData?.totalNoOfRecords?.totalNoOfRecords > 10 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={4} sm={12}></Grid>
      </Grid>
      <DeleteModal
        setOpen={setOpen}
        open={open}
        deleteAction={deleteInstitutionAction}
        active={activeInstitution}
        textmsg={
          "Are you sure you want to chage the status of this Institution?"
        }
        component={"institution"}
      />
    </Stack>
  );
};

export default Institutions;
